<template>
  <div class="full-width">
    <transition name="fade">
      <div v-if="isSent">
        <div class="flex justify-center q-mt-lg text-16-400">
          <div>
            <div class="text-center">
              {{ $t('text.newPasswordIsSet') }}
            </div>
            <div>
              {{ $t('text.nowYouCanLogin') }}
            </div>
          </div>
        </div>
        <div class="q-mt-xl flex justify-center">
          <AppButton
            :label="$t('button.login')"
            full-width
            :to="toLogin"
            text-color="dark"
            icon-right="fl:arrow_right-1"
            type="submit"
            align="between"
          />
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="!isSent">
        <q-form @submit="onSubmit">
          <div class="column q-mt-lg">
            <AppPassword
              ref="password"
              v-model="form.newPassword"
              :rules="[RULES.REQUIRED]"
              :placeholder="$t('label.newPassword')"
              class="q-mt-md"
              icon="mail"
              lazy-rules
              outlined
            />
            <AppPassword
              ref="password"
              v-model="form.confirmPassword"
              :rules="[RULES.REQUIRED, val => val === form.newPassword
                || $t('error.passwordIsNotMatched')]"
              :placeholder="$t('label.newPasswordConfirmation')"
              class="q-mt-md"
              lazy-rules
              outlined
            />
          </div>
          <div class="flex q-mt-sm">
            <AppButton
              :disabled="isLoading"
              :label="$t('lead.changePassword')"
              :loading="isLoading"
              full-width
              text-color="dark"
              icon-right="fl:refresh"
              type="submit"
              align="between"
            />
          </div>
        </q-form>
      </div>
    </transition>
  </div>
</template>

<script>
import AppPassword from 'common/components/AppPassword';
import AppButton from 'common/components/buttons/AppButton';
import { INVALID_CONFIRMATION_CODE } from 'common/enums/errorCodes';
import handleError from 'common/helpers/handleError';
import { notifyError, notifySuccess } from 'common/helpers/notify';
import rules from 'common/helpers/rules';

export default {
  name: 'ResetPasswordForm',
  components: {
    AppPassword,
    AppButton,
  },
  data() {
    return {
      form: {
        email: undefined,
        confirmCode: undefined,
        newPassword: undefined,
        confirmPassword: undefined,
      },
      isSent: false,
      isLoading: false,
      isHidePassword: true,
    };
  },
  computed: {
    RULES: () => rules,
    toLogin() {
      return { name: ENUMS.ROUTES.AUTH.SIGNIN };
    },
  },
  created() {
    const { email, language } = this.$route.query;
    this.form.confirmCode = this.$route.params.code;
    this.form.email = email;
    if (language) {
      this.$i18n.locale = language;
    }
  },
  methods: {
    async onSubmit() {
      try {
        this.isLoading = true;
        const form = {
          ...this.form,
          newPassword: btoa(this.form.newPassword),
          confirmPassword: btoa(this.form.confirmPassword),
        };
        await this.$axios.put('user/restore-password/confirm', form);
        this.isSent = true;
        notifySuccess(this.$t('Success'));
      } catch (error) {
        if (error.response?.data?.code === INVALID_CONFIRMATION_CODE) {
          notifyError(this.$t('error.restorePassword'));
        } else {
          handleError(error);
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
